import { render, staticRenderFns } from "./cancel-extra-benefit-table.vue?vue&type=template&id=81e92f18&scoped=true&"
import script from "./cancel-extra-benefit-table.vue?vue&type=script&lang=js&"
export * from "./cancel-extra-benefit-table.vue?vue&type=script&lang=js&"
import style0 from "./cancel-extra-benefit-table.vue?vue&type=style&index=0&id=81e92f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e92f18",
  null
  
)

export default component.exports